module.exports = __webpack_public_path__ + "img/biaozhun@2x.4fe3eae2.png";